import { render } from "./RowBienImmo.vue?vue&type=template&id=be7ff2cc"
import script from "./RowBienImmo.ts?vue&type=script&lang=js"
export * from "./RowBienImmo.ts?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__